import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function AppointmentQueueIcon({ width = 24, height = 24, color = '#e8eaed' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M10.95 18.35L7.4 14.8l1.45-1.45 2.1 2.1 4.2-4.2 1.45 1.45-5.65 5.65ZM5 22q-.825 0-1.413-.587Q3 20.825 3 20V6q0-.825.587-1.412Q4.175 4 5 4h1V2h2v2h8V2h2v2h1q.825 0 1.413.588Q21 5.175 21 6v14q0 .825-.587 1.413Q19.825 22 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Zm0 0V6v2Z"
        fill={color}
      />
    </Svg>
  );
}

export default AppointmentQueueIcon;
